import _styled from '@emotion/styled/base';
import { COLORS, ZIndex } from '@tablekit/theme';
import { Typography } from '@tablekit/typography';
import { getThemeValue } from '@tablekit/utils';
import { inlineDialogThemeNamespace, inlineDialogClassicTheme } from './themes.js';

var Container = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1dvshlo1"
} : {
  target: "e1dvshlo1",
  label: "Container"
})("background-color:", getThemeValue("".concat(inlineDialogThemeNamespace, ".backgroundColor"), inlineDialogClassicTheme.backgroundColor), ";color:", getThemeValue("".concat(inlineDialogThemeNamespace, ".textColor"), inlineDialogClassicTheme.textColor), ";box-shadow:0px 0px 6px ", COLORS.GRAY_TRANSLUCENT.L4, ";z-index:", ZIndex.Modal, ";", Typography.Body2, ";");

var InlineDialogContainer = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1dvshlo0"
} : {
  target: "e1dvshlo0",
  label: "InlineDialogContainer"
})("position:relative;", Typography.Body2, ";");

export { Container, InlineDialogContainer };
